import { filter, takeUntil } from 'rxjs/operators';
import { NavigationEnd, Router } from '@angular/router';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Constant } from 'src/app/constant/constant';
import { Location } from '@angular/common';
import { Subject } from 'rxjs';

@Component({
  selector: 'calsoft-image-import',
  templateUrl: './image-import.component.html',
  styleUrls: ['./image-import.component.scss']
})
export class ImageImportComponent implements OnInit, OnDestroy {

  url = '';
  sanitizedUrl = '';


  constructor(  private snackBar: MatSnackBar, public loc: Location, private router: Router) {
    this.url = this.router.url || '';
    this.sanitizedUrl = this.sanitizeUrl(this.url);
    this.router.events.pipe(filter((e: any) => e instanceof NavigationEnd), takeUntil(this._onDestroy)).subscribe(() => {
      this.url = this.router.url || '';
      this.sanitizedUrl = this.sanitizeUrl(this.url);
    });

      this.url = this.router.url || '';
          this.router.events
            .pipe(filter((e: any) => e instanceof NavigationEnd), takeUntil(this._onDestroy))
            .subscribe(() => { this.url = this.router.url || ''; });
 }

  ngOnInit(): void {
  }

  zipStatus: boolean;
  thirdFormGroup: UntypedFormGroup;
  zipFailedList: any;


  getResult(event) {


    if (event['status_code'] == Constant.RESPONSE_SUCCESS) {

      this.zipStatus = true;

      if (event.datalist[1]['failure'] != null) {
        this.zipFailedList = event.datalist[1]['failure'];
      } else {
        this.zipFailedList = [];
      }

    } else {
      this.snackBar.open(event['status_message'], '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 500 });
    }


  }

  back() {
    this.loc.back();
  }

  sanitizeUrl(u: string): string {
    return (u || '')
      .replace(/^\/+/, '')
      .replace(/[?#&=]/g, '-')
      .replace(/[^a-zA-Z0-9_-]+/g, '-')
      .replace(/-+/g, '-')
      .replace(/^-|-$/g, '')
      .toLowerCase();
  }

    protected _onDestroy = new Subject<void>();

    ngOnDestroy() {
        this._onDestroy.next();
        this._onDestroy.complete();
    }
}
